import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DataShareService } from '../shared/data-share.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CrudService } from '../shared/crud.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { Lightbox as box } from "ngx-lightbox";

@Component({
  selector: 'app-trader-list',
  templateUrl: './trader-list.component.html',
  styleUrls: ['./trader-list.component.css']
})
export class TraderListComponent implements OnInit, OnDestroy {
  @ViewChild("imageGrid") imageGridRef!: ElementRef;
  public tradersList = [];
  public imageUrl = environment.imageUrl;
  // sum = 2;
  sum = 6;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 1;
  direction = '';
  lazyLoadArray = [];
  lat: number;
  lng: number;
  previewImageOnly: boolean = false;
  public propertyImageURL = environment.imageUrl + "uploads/thumb/";
  p1: number = 1; // use with pagination
  p2: number = 1;
  markers: Marker[] = [
    {
      lat: -33.8688197,
      lng: 151.2092955,
      label: 'Agent 1'
    },
    {
      lat: -33.8466668,
      lng: 151.072701,
      label: 'Agent 2'
    },
    {
      lat: -33.8465088,
      lng: 151.0722137,
      label: 'Agent 3'
    },
    {
      lat: -33.8692736,
      lng: 151.2043244,
      label: 'Agent 4'
    }
  ];
  private subscriptions: Subscription = new Subscription();
  traderSearchObj = {};
  recentSearch = {};
  propertyDetails = {};
  suggestedTradersList = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: CrudService,
    private dataShare: DataShareService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private titleService: Title,
    private _lightbox: box,
  ) {
    this.titleService.setTitle(this.route.snapshot.data['title']);
    window.scrollTo(0, 0);
    this.spinner.show('outer');
    this.recentSearch = JSON.parse(localStorage.getItem('recentSearches'));
    this.traderSearchObj = JSON.parse(localStorage.getItem('trader_data_obj'));
  }

  ngOnInit() {
    this.subscriptions.add(
      this.dataShare.currentTradeAddress.subscribe(async traderObj => {
        var traderSearchObj = traderObj && traderObj['location'] && traderObj['location']['region'] ? traderObj : JSON.parse(localStorage.getItem('trader_data_obj'));
        if (traderSearchObj) {
          this.tradersList = [];
          this.lazyLoadArray = [];
          this.subscriptions.add(
            this.service.post('getOffMarketTraders', traderSearchObj).subscribe(res => {
              if (res['data'].length) {
                this.tradersList = res['data'];
                this.suggestedTradersList = res['suggestedTraders'];
                this.propertyDetails = res['property_detail'];
                this.appendItems(0, this.sum);
              } else {
                this.spinner.hide('outer');
              }
              const localtraderData = JSON.parse(localStorage.getItem('trader_data_obj'));
              this.lat = this.propertyDetails && this.propertyDetails['latitude'] ?  parseFloat(this.propertyDetails['latitude']) : localtraderData.lat;
              this.lng = this.propertyDetails && this.propertyDetails['longitude'] ? parseFloat(this.propertyDetails['longitude']) : localtraderData.lng;
              if (this.lat && this.lng) {
                this.getInitStreetMap();
                this.addGrabScroll();
              } else if (!this.previewImageOnly) {
                this.previewImageOnly = true;
              }
            })
          );
        }
        this.spinner.hide('outer');
      })
    );
  }

  appendItems(startIndex, endIndex) {
    console.log('appendItems function => ');
    this.addItems(startIndex, endIndex, 'push');
    this.spinner.hide('outer');
  }

  addItems(startIndex, endIndex, _method) {
    for (let i = startIndex; i < endIndex; ++i) {
      if (this.lazyLoadArray.length < this.tradersList.length) {
        this.lazyLoadArray[_method](this.tradersList[i]);
      }
      // console.log('this.lazyLoadArray => ', this.lazyLoadArray);
    }
  }

  onScrollDown() {
    console.log('scroll down => ');
    // add another 6 items
    const start = this.sum;
    // this.sum += 2;
    this.sum += 6;
    this.appendItems(start, this.sum);
    this.direction = 'down';
  }

  async getInitStreetMap() {
    const fenway = { lat: this.lat, lng: this.lng };
    console.log("fenway", fenway);
    const streetViewService = new google.maps.StreetViewService();
    const radius = 50; // Adjust radius as needed
    streetViewService.getPanorama(
      { location: fenway, radius: radius },
      (data, status) => {
        if (status === google.maps.StreetViewStatus.OK) {
          new google.maps.StreetViewPanorama(
            document.getElementById("cover-street-view") as HTMLElement,
            {
              position: fenway,
              pov: { heading: 185, pitch: 0 },
              zoom: 1,
            }
          );
          this.previewImageOnly = false;
        } else {
          const coverView = document.getElementById("cover-street-view");
          if (coverView) {
            coverView.innerHTML = `<img src="assets/images/default_property.png" alt="No Street View Available" style="width:100%;height:100%;object-fit:fill;">`;
          }
          this.previewImageOnly = true;
        }
      }
    );
  }

  addGrabScroll() {
    const container = this.imageGridRef.nativeElement;
    let isDown = false;
    let startX: number;
    let scrollLeft: number;

    container.addEventListener("mousedown", (e: MouseEvent) => {
      if ((e.target as HTMLElement).closest('.left-content')) return;
      isDown = true;
      container.classList.add("active");
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener("mouseleave", () => {
      isDown = false;
      container.classList.remove("active");
    });

    container.addEventListener("mouseup", () => {
      isDown = false;
      container.classList.remove("active");
    });

    container.addEventListener("mousemove", (e: MouseEvent) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2;
      container.scrollLeft = scrollLeft - walk;
    });
  }

  openImagePopup(imagePath, index) {
    const processedImages = imagePath.map(img => {
    const fullPath = (img.path.startsWith('http') || img.path.startsWith('https')) 
      ? img.path 
      : this.propertyImageURL + img.path;
    return {
      src: fullPath,
      thumb: fullPath,
      caption: ''
    };
  });
    this._lightbox.open(processedImages, index, {
      wrapAround: true,
      showImageNumberLabel: false,
      disableScrolling: false,
      positionFromTop: 100,
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}

// Map type Interface
interface Marker {
  lat: number;
  lng: number;
  label?: string;
}
